import { ToggleState } from '@dgx-pr-spa/shared/util';
import {
  Component,
  ChangeDetectionStrategy,
  Output,
  EventEmitter,
  Input,
} from '@angular/core';
import { slideInOut } from '@dgx-pr-spa/shared/util';

@Component({
  selector: 'app-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [slideInOut],
})
export class AccordionComponent {
  /**
   * Emits toggled event when accordion is clicked
   */
  @Output() toggled: EventEmitter<string> = new EventEmitter();

  /**
   * Tracks accordion open/closed state
   */
  @Input() isOpen = false;

  /**
   * Sets the direction of which the content display - default bottom
   */
  @Input() isReversed = false;

  /**
   * Sets styling for stepper accordion variation
   */
  @Input() isStepper = false;

  /**
   * Boolean value to display stepper edit link
   */
  @Input() hasStepperEdit = false;

  /**
   * Triggered when the user clicks the accordion header
   */
  onToggleClick() {
    this.isOpen = !this.isOpen;
    this.toggled.emit(this.isOpen ? ToggleState.open : ToggleState.closed);
  }
}
